import { render, staticRenderFns } from "./MagicNineTurn.vue?vue&type=template&id=8c5c16c8&scoped=true"
import script from "./MagicNineTurn.vue?vue&type=script&lang=js"
export * from "./MagicNineTurn.vue?vue&type=script&lang=js"
import style0 from "./MagicNineTurn.vue?vue&type=style&index=0&id=8c5c16c8&prod&scoped=true&lang=css"
import style1 from "./MagicNineTurn.vue?vue&type=style&index=1&id=8c5c16c8&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c5c16c8",
  null
  
)

export default component.exports